import React from 'react'
import className from 'classnames/bind'

import { getVideoSourcesList } from 'app/services/utils/video-formating.service'
import { CKLA_PUBLIC_ASSETS } from 'app/constants/api.constants'

import { Button } from 'app/components/common/'
import OpenModalButton from 'app/components/buttons/open-modal-button/open-modal-button.component'

import VideoModal from 'app/components/modal/custom-modal/video-modal.component'

import stylesModule from 'app/components/buttons/error-learn-more/error-learn-more.module.scss'

const cx = className.bind(stylesModule)

const videoSources = getVideoSourcesList(CKLA_PUBLIC_ASSETS)

const posterUrl =
  'https://learning.amplify.com/m/4ac4f0ba53690a6c/original/ckla_hub_overview.jpg'

type LearnMoreButtonProps = {
  openModal: () => void
}

const LearnMoreButton = ({ openModal }: LearnMoreButtonProps) => (
  <Button
    onClick={openModal}
    className={cx('learn-more-button', 'button--oval-blue')}
  >
    Learn More
  </Button>
)

type LearnMoreModalProps = {
  close: () => void
}

const LearnMoreModal = ({ close }: LearnMoreModalProps) => (
  <VideoModal poster={posterUrl} sources={videoSources} close={close} />
)

const LearnMoreModalButton = () => (
  <OpenModalButton ModalButton={LearnMoreButton} Modal={LearnMoreModal} />
)

export default LearnMoreModalButton
